import { updateDevice } from 'modules/devices/store/actions';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch } from 'store/hooks';

export function useUpdateDevice(refetch: () => void) {
  const { t } = useLingui();
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const mutate = useCallback(
    async (id: number, params: Partial<{ name: string; tournament_id: number }>) => {
      setIsLoading(true);
      try {
        await dispatch(updateDevice({ id, params })).unwrap();
        toast.success(t`Устройство обновлено`);
        refetch();
      } catch {
        toast.error(t`Не удалось обновить устройство`);
      } finally {
        setIsLoading(false);
      }
    },
    [dispatch, refetch, t],
  );

  return { mutate, isLoading };
}
